import React from "react";
import styles from "./Downloads.module.scss";

const Downloads: React.FC = () => {
  return (
    <section className={styles.downloads}>
      <h2 className={styles.title}>Схемы и материалы для скачивания</h2>
      <p className={styles.subtitle}>Раздел в разработке. Список файлов будет добавлен позже.</p>
    </section>
  );
};

export default Downloads;
